import React, { useState, useEffect } from 'react';
import './Navbar.css';
import logoImg from '../images/aby logo.png';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [currentTime, setCurrentTime] = useState('');
  const [activeSection, setActiveSection] = useState('home');

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);

      // Active section detection
      const sections = ['home', 'about', 'skills', 'works', 'certifications', 'contact'];
      for (let i = sections.length - 1; i >= 0; i--) {
        const el = document.getElementById(sections[i]);
        if (el && window.scrollY >= el.offsetTop - 120) {
          setActiveSection(sections[i]);
          break;
        }
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      setCurrentTime(
        now.toLocaleTimeString('en-IN', {
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: true,
          timeZone: 'Asia/Kolkata',
        }) + ', IST'
      );
    };
    updateTime();
    const id = setInterval(updateTime, 1000);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  const scrollTo = (id) => {
    setMenuOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
    else window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const navLinks = [
    { id: 'home', label: 'Home' },
    { id: 'about', label: 'About' },
    { id: 'skills', label: 'Skills' },
    { id: 'works', label: 'Works' },
    { id: 'certifications', label: 'Certifications' },
    { id: 'contact', label: 'Contact' },
  ];

  const socials = [
    { label: 'GitHub', href: 'https://github.com/Abincleetus007' },
    { label: 'LinkedIn', href: 'https://www.linkedin.com/in/abin-cleetus-1b9143277/' },
    { label: 'Email', href: 'mailto:abincletus007@gmail.com' },
  ];

  return (
    <>
      <nav className={`navbar${scrolled ? ' navbar--scrolled' : ''}`}>
        <button
          id="nav-logo"
          className="navbar__logo"
          onClick={() => scrollTo('home')}
          aria-label="Go to top"
        >
          <img src={logoImg} alt="Abin Cleetus" className="navbar__logo-img" />
        </button>

        <button
          id="nav-menu-toggle"
          className={`menu-btn${menuOpen ? ' menu-btn--open' : ''}`}
          onClick={() => setMenuOpen((v) => !v)}
          aria-label="Toggle navigation menu"
          aria-expanded={menuOpen}
        >
          <span className="menu-btn__line" />
          <span className="menu-btn__line" />
        </button>
      </nav>

      {/* Overlay */}
      <div
        className={`overlay${menuOpen ? ' overlay--open' : ''}`}
        aria-hidden={!menuOpen}
      >
        <div className="overlay__inner">
          <div className="overlay__cols">
            {/* Nav links */}
            <div className="overlay__col">
              <p className="overlay__label">MENU</p>
              {navLinks.map(({ id, label }) => (
                <button
                  key={id}
                  id={`menu-${id}`}
                  className={`overlay__link${activeSection === id ? ' overlay__link--active' : ''}`}
                  onClick={() => scrollTo(id)}
                >
                  <span>{label}</span>
                  <span className="overlay__arrow">↗</span>
                </button>
              ))}
            </div>

            {/* Socials */}
            <div className="overlay__col">
              <p className="overlay__label">SOCIALS</p>
              {socials.map(({ label, href }) => (
                <a
                  key={label}
                  id={`menu-social-${label.toLowerCase()}`}
                  className="overlay__link"
                  href={href}
                  target={href.startsWith('http') ? '_blank' : undefined}
                  rel="noopener noreferrer"
                  onClick={() => setMenuOpen(false)}
                >
                  <span>{label}</span>
                  <span className="overlay__arrow">↗</span>
                </a>
              ))}
            </div>
          </div>

          <div className="overlay__footer">
            <p className="overlay__time-label">LOCAL TIME</p>
            <p className="overlay__time">{currentTime}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;